import { useState } from "react";
import { Link, Redirect } from "react-router-dom";

import { useMutation } from "@tanstack/react-query";
import {
  Flex,
  Label,
  Panel,
  Button,
  Heading1,
  FormGroup,
  TextInput,
} from "@sopranodesign/pulse-components";

import { Logo } from "../../Components/Logo";
import { passwordRequest } from "../../api/auth";

const PasswordRequest = () => {
  const [email, setEmail] = useState("");
  const [redirect, setRedirect] = useState(false);

  const handleEmailChange = (e) => setEmail(e.target.value);

  const mutation = useMutation({
    mutationFn: passwordRequest,
    onSuccess: () => {
      setRedirect(true);
    },
  });

  const handleSubmit = (event) => {
    event.preventDefault();

    mutation.mutate({ email });
  };

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: "/login",
          // state: {
          //   notification: {
          //     type: "success",
          //     message: "You have been successfully logged In.",
          //   },
          // },
        }}
      />
    );
  }

  return (
    <Panel>
      <Flex col pad half mxAuto middle yScreen style={{ maxWidth: "25%" }}>
        <Flex middle mb>
          <Logo />
        </Flex>
        <Heading1 style={{ fontSize: "2rem" }} mb textCenter>
          Request New Password
        </Heading1>

        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="email">Email</Label>
            <Flex relative>
              <TextInput
                id="email"
                aria-label="email-input"
                placeholder="Email"
                value={email}
                onChange={handleEmailChange}
              />
            </Flex>
          </FormGroup>
          <Flex ySpace center col>
            <Button
              aria-label="submit button"
              variant="primary"
              fat
              mt
              middle
              type="submit"
              loading={mutation.isPending}
              disabled={!email}
            >
              Request a new password
            </Button>
            <Button as={Link} to="/login" variant="inline">
              Take me back I remember
            </Button>
          </Flex>
        </form>
      </Flex>
    </Panel>
  );
};

PasswordRequest.propTypes = {};

export default PasswordRequest;
